<div class="presentation-thumbprint" (click)="toggle($event)">
  <h3>THUMBPRINT</h3>
  <h3>HERE</h3>
</div>
